import React from "react";
import { Skeleton } from "@mui/lab";

export const ServiceRequestCardSkeleton: React.FC = () => {
    return (
        <div className="bg-white rounded-xl shadow-md border border-gray-200 overflow-hidden">
            {/* Status Badge Skeleton */}
            <div className="p-4 pb-0">
                <Skeleton
                    variant="rectangular"
                    width={120}
                    height={32}
                    className="rounded-full"
                />
            </div>

            {/* Card Content */}
            <div className="p-4 space-y-3">
                {/* Tracking ID */}
                <div className="flex items-center justify-between">
                    <Skeleton variant="text" width={80} height={16} />
                    <Skeleton variant="text" width={100} height={20} />
                </div>

                {/* Subject Name */}
                <div>
                    <Skeleton variant="text" width="80%" height={24} />
                    <Skeleton variant="text" width="60%" height={16} className="mt-2" />
                </div>

                {/* Request Type */}
                <div className="flex items-start space-x-2">
                    <Skeleton variant="circular" width={20} height={20} />
                    <div className="flex-1 space-y-1">
                        <Skeleton variant="text" width={60} height={14} />
                        <Skeleton variant="text" width="90%" height={18} />
                    </div>
                </div>

                {/* Assignee */}
                <div className="flex items-center space-x-2">
                    <Skeleton variant="circular" width={20} height={20} />
                    <div className="flex-1 space-y-1">
                        <Skeleton variant="text" width={50} height={14} />
                        <Skeleton variant="text" width="70%" height={18} />
                    </div>
                </div>

                {/* Date Info */}
                <div className="flex items-center space-x-2">
                    <Skeleton variant="circular" width={20} height={20} />
                    <div className="flex-1 space-y-1">
                        <Skeleton variant="text" width={100} height={14} />
                        <Skeleton variant="text" width={80} height={14} />
                    </div>
                </div>
            </div>
        </div>
    );
};

